import React from "react";

const whatsappNumber = "919035296763"; // e.g., 919035296763

const WhatsappButton = () => (
  <a
    href={`https://wa.me/${whatsappNumber}`}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      position: "fixed",
      right: "20px",
      bottom: "20px",
      zIndex: 1000,
      // background: "#25D366",
      // color: "#fff",
      // borderRadius: "50%",
      // width: "60px",
      // height: "60px",
      // display: "flex",
      // alignItems: "center",
      // justifyContent: "center",
      // boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      // fontSize: "32px",
      textDecoration: "none",
    }}
    aria-label="Chat on WhatsApp"
    title="Whatsapp Chat with Kishore" // <-- Tooltip on hover 
  >
    {/* <span role="img" aria-label="WhatsApp">💬</span> */}
    <img
      src="./whatsapp-logo1-64.png"  //image from https://www.flaticon.com/
      alt="WhatsApp"
      style={{ width: "64px", height: "64px" }}
    />
  </a>
);

export default WhatsappButton;